import { createApp } from 'vue';
import LocationSwitcher from '@/components/LocationSwitcher.vue';
import { registerIsland } from '@/shared/islands.js';

// Registered rather than swept, so the control still appears when the page content is
// replaced without a reload (docs/homepage-location-swap.md). Every match rather than one
// by id, following the product page's own entry: a long page could reasonably offer the
// choice more than once.
//
// Worth knowing if this ever lands on a homepage: this widget RELOADS the page when its
// value changes (LocationSwitcher.vue, via locationReload.js), which the header's Where
// field no longer does there. The two would then disagree about how a spa change is
// applied on that one page. Nothing includes it on a homepage today - it is for pages
// whose own content is priced against the spa - and making it swap instead is a decision
// for whoever needs that, not a change to make in passing.
registerIsland('[data-location-switcher]', (el) => createApp(LocationSwitcher, {
    locations: JSON.parse(el.dataset.locations ?? '[]'),
    nearestLocationsUrl: el.dataset.nearestLocationsUrl,
    // Number('') is 0 where no spa is chosen; || null keeps the prop's "none" a real null.
    locationId: Number(el.dataset.locationId) || null,
}));
